













































import {
  Component, Mixins, Prop,
} from 'vue-property-decorator';
import { State } from 'vuex-class';
import FieldComponentsFormData from '@/mixins/FieldComponentsFormData';
import DotToggler from '@/components/DotToggler.vue';
import { CrudOperation } from '@/types/CrudOperation';

@Component({
  components: {
    DotToggler,
  },
})
export default class FieldCollection extends Mixins(FieldComponentsFormData) {
  active = 0;

  @Prop(String)
  readonly collection!: string;

  @Prop({ default: () => [] })
  readonly value!: any;

  @Prop()
  readonly label!: string;

  @Prop()
  readonly layoutOptions!: any;

  @State('operation', { namespace: 'entity' })
  operation!: CrudOperation;

  get valueLength() {
    return this.value?.length || 0;
  }

  get isRead() {
    return this.operation === CrudOperation.read;
  }

  get fieldCollectionName() {
    return this.layoutOptions?.allowedTypes?.[0] || null;
  }

  async beforeMount() {
    this.bindFormDataValues();
  }

  bindFormDataValues() {
    const values = this.value || [];
    values.forEach(({ __typename, index, ...value }: Record<string, any>, i: number) => {
      this.formData[`collection${i}`] = { ...value };
    });
  }

  onChange(index: number, fieldName: string, value: any) {
    const values = Object.values(this.formData);
    values[index][fieldName] = value;
    this.$emit('input', values);
  }

  onClickAddButton() {
    const index = this.valueLength || 0;
    this.addEmptyCollectionItemAt(index);
    const values = Object.values(this.formData);
    this.$emit('input', values);
    this.setActiveWindow(index);
  }

  addEmptyCollectionItemAt(index: number) {
    this.formData[`collection${index}`] = this.createEmptyCollectionItem();
  }

  createEmptyCollectionItem() {
    const keys = this.fieldComponents.map((f) => f.name);
    const entries = keys.map((k) => [k, undefined]);
    return Object.fromEntries(entries);
  }

  setActiveWindow(i: number) {
    this.active = i;
  }
}
